import * as React from "react";
import type { SVGProps } from "react";
const SvgMinimise01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={2}
      d="M2.4 15.456h3.867c1.178 0 2.133.917 2.133 2.048V21.6m0-19.2v4.096c0 1.131-.955 2.048-2.133 2.048H2.4m19.2 6.912h-3.867c-1.178 0-2.133.917-2.133 2.048V21.6m0-19.2v4.096c0 1.131.955 2.048 2.133 2.048H21.6"
    />
  </svg>
);
export default SvgMinimise01;
